import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../../../utilz';
import { getProcurementLaneListInFail, getProcurementLaneListInSuccess } from './ProcurementLaneActions';
import { getLaneListEffect } from './ProcurementLaneEffects';
import ProcurementLaneType from './ProcurementLaneTypes';

export const procurementLane = (state) => state.procurementLane;

function removeEmptyObjects(obj) {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      removeEmptyObjects(obj[key]);
    } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

function* getRouteLaneListAction() {
  try {
    const { laneListReq } = yield select(procurementLane);
    const requetParams = yield call(removeEmptyObjects, laneListReq);
    const { data } = yield call(getLaneListEffect, requetParams);
    yield put(getProcurementLaneListInSuccess({ data: data }));
  } catch (e) {
    yield put(getProcurementLaneListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* procurementLaneSaga() {
  yield takeEvery(ProcurementLaneType.GET_PROCUREMENT_LANE_LIST, getRouteLaneListAction);
}
